export enum AttribTypeEnum {
  Lookup = 1,
  Integer = 2,
  Boolean = 3,
  Char = 4,
  Decimal = 5,
  DateTime = 6
}
